import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
  maxWidthClass?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, maxWidthClass = 'max-w-md' }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className={"w-full " + maxWidthClass}>
          {children}
        </div>
      </div>
      <footer className="bg-white border-t border-secondary-200">
        <div className="px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-secondary-600">
            <div>Powered by <span className="font-medium">IDS</span> © {new Date().getFullYear()}</div>
            <div className="text-secondary-400">All rights reserved.</div>
          </div>
        </div>
      </footer>
    </div>
  );
};
